/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type UpdateUserInput = {
  id: string;
  username?: string | null;
  email?: string | null;
  name?: string | null;
  profilePictureUrl?: string | null;
  cognitoIdentityId?: string | null;
  geoPoints?: Array<string | null> | null;
  assetGroupCount?: number | null;
  assetCount?: number | null;
  organizations?: Array<string | null> | null;
  organizationIds?: Array<string | null> | null;
  termsAndConditionsReviewed?: TermsAndConditionsStatusEnum | null;
  termsAndConditionsLocation?: string | null;
};

export enum TermsAndConditionsStatusEnum {
  True = "True",
  False = "False",
  Custom = "Custom",
  Updated = "Updated",
}

export type UpdateUserMutation = {
  updateUser?: {
    id: string;
    username: string;
    email: string;
    name: string;
    profilePictureUrl?: string | null;
    cognitoIdentityId?: string | null;
    termsAndConditionsReviewed?: TermsAndConditionsStatusEnum | null;
    termsAndConditionsLocation?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};